import api from 'api';
import { source as SOURCE } from 'constants/notifications';

export const SET_NOTIFICATION_CENTER_MODAL_STATE = 'SET_NOTIFICATION_CENTER_MODAL_STATE';
export const SET_NOTIFICATION_CENTER_LOADING_STATE = 'SET_NOTIFICATION_CENTER_LOADING_STATE';
export const FETCH_NOTIFICATIONS_ASYNC_SUCCESS = 'FETCH_NOTIFICATIONS_ASYNC_SUCCESS';
export const NOTIFICATIONS_ASYNC_ERROR = 'NOTIFICATIONS_ASYNC_ERROR';
export const FETCH_INGREDIENT_ASYNC_ERROR = 'FETCH_INGREDIENT_ASYNC_ERROR';
export const SET_SELECTED_NOTIFICATION = 'SET_SELECTED_NOTIFICATION';
export const SET_NOTIFICATION_STEP = 'SET_NOTIFICATION_STEP';

const setLoadingStatus = (isLoading) => {
  return {
    type: SET_NOTIFICATION_CENTER_LOADING_STATE,
    payload: isLoading,
  };
};

export const setNotificationCenterModalState = (isOpen, source = SOURCE.NOTIFICATIONS) => {
  return {
    type: SET_NOTIFICATION_CENTER_MODAL_STATE,
    payload: {
      isOpen,
      source,
    }
  };
};

const fetchNotificationsAsyncSuccess = (notifications) => {
  return {
    type: FETCH_NOTIFICATIONS_ASYNC_SUCCESS,
    payload: notifications,
  };
};

const notificationsAsyncError = (error) => {
  return {
    type: NOTIFICATIONS_ASYNC_ERROR,
    payload: error,
  };
};

const fetchIngredientAsyncError = (error) => {
  return {
    type: FETCH_INGREDIENT_ASYNC_ERROR,
    payload: error,
  };
};

export const setSelectedNotification = notification => ({
  type: SET_SELECTED_NOTIFICATION,
  payload: { notification: notification || {} },
});

export const setNotificationStep = step => ({
  type: SET_NOTIFICATION_STEP,
  payload: { step },
});

/**
 * Fetch all unresolved notifications for the brand
 *
 * @param {String} ingredType ingredient type CI-customer Ingredient SP-sysco product
 */
export const fetchNotificationsAsync = () => {
  return (dispatch) => {
    dispatch(setLoadingStatus(true));
    return api.request('notifications', 'get')
      .then(data => dispatch(fetchNotificationsAsyncSuccess(data)))
      .catch(err => {
        console.log('Error :', err);
        dispatch(notificationsAsyncError(err.message));
      })
      .finally(() => dispatch(setLoadingStatus(false)));
  };
};

/**
 * Update notification
 * @param {*} id notification id
 * @param {*} status updated notification status
 */
export const updateNotificationAsync = (id, status) => {
  return (dispatch) => {
    return api.request(`notifications/${ id }`, 'put', { status })
    .then(() => dispatch(fetchNotificationsAsync()))
    .catch(err => {
      console.log('Error :', err);
      dispatch(notificationsAsyncError(err.message));
    });
  };
};

/**
 * Fetch Ingredient with used in recipes
 * @param {*} supc
 * @returns isAbleToResolve
 */
export const fetchIngredientUsedInRecipesAsync = (supc) => {
  return (dispatch) => {
    dispatch(setLoadingStatus(true));
    return api.request(`ingredient?supc=${ supc }`, 'get')
      .then(data => {
        console.log('Ingredient used in recipes: ', data);
        return data;
      })
      .catch(err => {
        console.log('Error :', err.message);
        dispatch(fetchIngredientAsyncError(err && err.message));
        throw err;
      })
      .finally(() => dispatch(setLoadingStatus(false)));
  };
};

/**
 * request for the unavailable cost-rollup
 * @param {Object} payload request payload
 * @returns {Promise} request promise
 */
export const replaceCostRollUp = payload => {
  return (dispatch) => {
    dispatch(setLoadingStatus(true));
    return api.request(`global-price-updates?isUnavailableItemCostRollUp=true`, 'post', payload)
      .finally(() => dispatch(setLoadingStatus(false)));
  };
};
